<template>
  <div class="list-group-item" :style="`background-color: ${backgroundColor}`">
    <form id="requirement-details-maintenance">
      <div style="display: grid; grid-template-rows: repeat(4, 1fr); grid-template-columns: repeat(7, 1fr); grid-column-gap: 0.75rem;">
        <b-form-group label="Part #" style="grid-column: 1;">
          <b-input-group size="sm" >
            <b-input-group-append v-if="(checkClaim(CAN_ADD_PARTS) || checkClaim(CAN_EDIT_PARTS))">
              <b-button variant="light" @click="$bvModal.show('part-maintenance-model')" :disabled="havePart">
                <i v-show="this.part.id == undefined || this.part.id == null || this.part.id == 0" class="part-lookup--plus fa fa-plus"></i>
                <i v-show="this.part.id > 0" class="part-lookup--plus fa fa-pencil"></i>
              </b-button>
            </b-input-group-append>
            <vue-simple-suggest
              class="suggest-input form-control"
              :styles="autoCompleteStyle"
              :list="getList"
              v-model="chosenPartNumber"
              :max-suggestions="20"
              :min-length="2"
              :debounce="750"
              :filter-by-query="true"
              value-attribute="id"
              display-attribute="partNumber"
              @select="onSuggestSelect"
              @input="onSuggestChange"
              :class="{ 'is-invalid': ($v.chosenPartNumber.$error && requirementLine[reqFields.REQUIREMENT_ID] === 0 ) }"
              @blur="onPartNumberBlur"
              @request-done="onRequestDone"
              >
              <div slot="misc-item-below" v-if="isLoadingPart" class="misc-item">
                <span>Loading Part...</span>
              </div>
            </vue-simple-suggest>

          </b-input-group>
          <div class="invalid-feedback">
            <div v-if="!$v.chosenPartNumber.required && requirementLine[reqFields.REQUIREMENT_ID] === 0">Part Number is required</div>
          </div>
        </b-form-group>
        <!-- <b-form-group label="Part #" style="grid-column: 1;" v-else>
          <b-form-input v-model="chosenPartNumber" disabled />
        </b-form-group> -->
        <b-form-group :label="CompanyPNLabel" style="grid-column: 1;" class="mt-1">
          <b-form-input v-model="line[reqFields.CUSTOMER_PN]"></b-form-input>
        </b-form-group>

        <b-form-group label="Alternate PN" style="grid-column: 1;" class="mt-1">
          <b-form-input v-model="part[reqFields.ALT_NUMBER]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
        </b-form-group>
        <b-form-group label="NSN" style="grid-column: 1;" class="mt-1">
          <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.NSN_NUMBER]"></b-form-input>
        </b-form-group>
        <b-form-group label="Harmonized Code" style="grid-column: 1;" class="mt-1">
          <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.HARMONIZED_CODE]"></b-form-input>
        </b-form-group>
        <b-form-group label="Schedule B" style="grid-row: 6; grid-column: 1;" class="mt-1">
          <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.SCHEDULE_B]"></b-form-input>
        </b-form-group>
        <b-form-group label="ECCN" style="grid-row: 6; grid-column: 2;" class="mt-1">
          <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.ECCN]"></b-form-input>
        </b-form-group>
        <!--Show this block when we are receiving an PO item-->
        <!-- <div v-if="receiveItemDetail" class="d-flex justify-content-start mb-1">
          <b-form-group label="PO Qty" width="200" class="mr-2">
            <b-form-input v-model="line[reqFields.QUANTITY]" type="number" disabled></b-form-input>
          </b-form-group>
          <b-form-group label="Qty Received" labelCols="6" width="144" class="mr-2">
            <b-form-input v-model="line[invFields.QTY_AVAILABLE]" type="number"></b-form-input>
          </b-form-group>
          <b-form-group label="Qty Rejected" labelCols="6" width="241" class="mr-2">
            <b-form-input v-model="line[invFields.QTY_REJECTED]" type="number"></b-form-input>
          </b-form-group>
          <b-form-group label="Cost" labelCols="6" width="155" class="mr-2">
            <b-form-input v-model="line[invFields.COST]" type="number"></b-form-input>
          </b-form-group>
        </div> -->
          <b-form-group label="Mfr" style="grid-row: 1; grid-column: 2;" class="mr-2">
            <lookup-dropdown label="Manufacturer" moduleName="mfrs" resource="inventoryManufacturer" propKey="inventorymanufacturerId"
              :value="part[reqFields.MANUFACTURER_ID]" :options="manufacturers" @change="onValueChangePart" :dropdownDisabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" />
          </b-form-group>

          <b-form-group label="Description" style="grid-row: 1; grid-column: 3/5" class="mr-2">
            <b-form-input v-model="part[reqFields.DESCRIPTION]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
          </b-form-group>

          <b-form-group label="Part Comments" style="grid-row: 1; grid-column: 5/7" class="mr-2">
            <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.PART_COMMENTS]"></b-form-input>
          </b-form-group>
          <b-form-group label="Qty" style="grid-row: 2; grid-column: 2;" class="mr-2 required">
            <b-form-input v-model.number="line[reqFields.QUANTITY]" type="number"
              :class="{ 'is-invalid': $v.line[reqFields.QUANTITY].$error }" @blur="$v.line[reqFields.QUANTITY].$touch()" ></b-form-input>
            <div class="invalid-feedback">
              <div v-if="!$v.line[reqFields.QUANTITY].required">Quantity is required</div>
            </div>
          </b-form-group>
          <b-form-group :label="PriceLabel" style="grid-row: 2; grid-column: 3;" class="mr-2 required">
            <b-form-input v-model.number="line[reqFields.PRICE]"
            :class="{ 'is-invalid': $v.line[reqFields.PRICE].$error }" @blur="$v.line[reqFields.PRICE].$touch()" type="number" min="0"></b-form-input>
            <div class="invalid-feedback">
              <div v-if="!$v.line[reqFields.PRICE].required">Price is required</div>
            </div>
          </b-form-group>
          <b-form-group label="Currency" style="grid-row: 2; grid-column: 4;" class="mr-2">
            <lookup-dropdown label="currency" moduleName="currencies" resource="currency" propKey="currencyTypeId"
              :value="header[reqFields.CURRENCY_TYPE_ID]" :options="currencies" @change="onValueChangeHeader"
              :dropdownDisabled="!!requirementLine[reqFields.REQUIREMENT_ID]" />
          </b-form-group>
          <b-form-group label="Exchange Rate" style="grid-row: 2; grid-column: 5;" class="mr-2">
            <b-form-input type="number" v-model.number="header[reqFields.EXCHANGE_RATE]" :disabled="addSources"></b-form-input>
          </b-form-group>
          <b-form-group label="Converted Price" style="grid-row: 2; grid-column: 6;" class="mr-2">
            <b-form-input type="number" :value="line.convertedPrice" readonly :disabled="!!requirementLine[reqFields.REQUIREMENT_ID]"></b-form-input>
          </b-form-group>
          <b-form-group :label="BuyPriceLabel" v-show="ShowBuyPrice" style="grid-row: 2; grid-column: 7;" class="mr-2">
            <b-form-input type="number" v-model="line.buyPrice"></b-form-input>
          </b-form-group>
          <b-form-group label="Date Code" style="grid-row: 3; grid-column: 2;" class="mr-2" :disabled="addSources">
            <b-form-input v-model="line[reqFields.DATE_CODE]"></b-form-input>
          </b-form-group>
          <b-form-group label="Lot" style="grid-row: 3; grid-column: 3;" class="mr-2" :disabled="addSources">
            <b-form-input v-model="line[reqFields.LOT_CODE]"></b-form-input>
          </b-form-group>
          <b-form-group label="Revision" style="grid-row: 3; grid-column: 4;" class="mr-2" :disabled="addSources">
            <b-form-input v-model="line[reqFields.REVISION]"></b-form-input>
          </b-form-group>
          <b-form-group label="Need Date" style="grid-row: 3; grid-column: 5;" class="mr-2">
            <date-picker v-model="line[reqFields.NEED_BY_DATE]" :config="datePickerOptions"></date-picker>
          </b-form-group>
          <b-form-group label="Testing Req'd" style="grid-row: 3; grid-column: 6;" class="mr-2" :disabled="addSources">
            <b-form-select v-model="line[reqFields.TESTING_REQUESTED]">
              <option v-for="(select, index) in sortSelect(testings)" :key="index" :value="select.value">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <!--b-form-group label="Ship Via" style="grid-row: 3; grid-column: 7;" class="mr-2">
            <b-form-select v-model="line[reqFields.SHIPPING_METHOD_ID]">
              <option v-for="(select, index) in sortSelect(shipViaList)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group-->
          <b-form-group label="Condition" style="grid-row: 4; grid-column: 2;" class="mr-2" :disabled="addSources">
            <lookup-dropdown label="condition" moduleName="conditions" resource="inventoryCondition"
              propKey="conditionId" :value="line[reqFields.CONDITION_ID]" :options="conditions" @change="onValueChangeLine" />
          </b-form-group>
          <b-form-group label="COO" style="grid-row: 4; grid-column: 3;" :disabled="addSources">
            <b-form-select v-model="line.countryOfOriginId">
              <option value="0"> </option>
              <option
                  v-for="(countryCode) in sortSelect(countryCodes)"
                  v-bind:key="countryCode.id"
                  v-bind:value="countryCode.id"
                >{{countryCode.name}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="SPQ" style="grid-row: 4; grid-column: 4;" class="mr-2" disabled>
            <b-form-input v-model="part[reqFields.PIECE_PER_PKG]"></b-form-input>
          </b-form-group>
          <b-form-group label="Min Order Qty" style="grid-row: 4; grid-column: 5;" class="mr-2" v-if="showMOQ" disabled>
              <b-form-input type="number" v-model="part[reqFields.MOQ]" ></b-form-input>
            </b-form-group>
          <b-form-group label="Class" style="grid-row: 5; grid-column: 2;" class="mr-2">
            <lookup-dropdown label="class" moduleName="classes" resource="inventoryClass" propKey="inventoryclassId"
              :value="part[reqFields.INVENTORY_CLASS_ID]" :options="classes" @change="onValueChangePart" :dropdownDisabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" />
          </b-form-group>
          <b-form-group label="Category" style="grid-row: 5; grid-column: 3;" class="mr-2">
            <b-form-select v-model="part[reqFields.INVENTORY_CATEGORY_ID]" :disabled="addSources || !!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" size="sm">
              <option v-for="(category) in sortSelect(categories)" :key="category.id" :value="category.id">{{category.name}}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Item Pkg" style="grid-row: 5; grid-column: 4;" class="mr-2">
            <lookup-dropdown label="packaging" moduleName="packaging" resource="inventoryPackaging"
              propKey="packageId" :value="part[reqFields.PACKAGE_ID]" :options="packaging" @change="onValueChangePart"
              :dropdownDisabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected" :overrideModalId="'requirements-packaging-modal'" />
          </b-form-group>
          <b-form-group label="Temp" style="grid-row: 5; grid-column: 5;" class="mr-2">
            <b-form-input v-model="part[reqFields.TEMP_RATING]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
          </b-form-group>
          <b-form-group label="RoHS" style="grid-row: 5; grid-column: 6;" class="mr-2">
            <b-form-select v-model="part[reqFields.LEAD_FREE]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" id="leadFree" size="sm">
              <option v-for="(value) in leadFreeValues" v-bind:key="value" v-bind:value="value">{{value}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Vendor Note" style="grid-row: 6; grid-column: 3/5;" class="mr-2" :disabled="addSources">
            <b-form-input v-model="line[reqFields.VENDOR_NOTE]"></b-form-input>
          </b-form-group>
          <b-form-group label="Comments"  style="grid-row: 6; grid-column: 5/7;" class="mr-2">
            <b-form-input v-model="line[reqFields.COMMENTS]"></b-form-input>
          </b-form-group>

          <b-modal id="part-maintenance-model" size="xl" ok-title="Save" scrollable hide-footer :title="(partId > 0) ? 'Edit Part' : 'Add Part'">
            <part-form :partId="partId" :partNumberProp="chosenPartNumber" @cancel="onPartModelClose" @partCreated="onPartCreated" @partUpdated="onPartUpdated" />
          </b-modal>
      </div>
     </form>
  </div>

</template>

<script>
/****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************/

import { mapState, mapGetters, mapActions } from 'vuex';
import VueSimpleSuggest from 'vue-simple-suggest';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

import { FIELDS as REQUIREMENT_FIELDS } from '@/pages/Requirements/constants';
import { FIELDS as INVENTORY_FIELDS } from '@/pages/Inventory/components/InventoryDetails/constants';

import { CRFQ_PART_STATUSES } from '@/pages/Requirements/constants';

import { DATE_FORMAT, AUTO_COMPLETE_STYLES, LEAD_FREE_VALUES, US_DOLLARS_CURRENCY_ID } from '@/shared/constants';

import FormElWrap from '@/shared/components/FormElWrap/index';
import PartForm from '@/pages/Parts/components/PartForm';

export default {
  components: {
    VueSimpleSuggest,
    FormElWrap,
    PartForm,
  },
  props: {
    crfqLineId: [Number, String],
    requirementId: [Number, String],
    addSources: [Boolean],
    pageName: [String],
    backgroundColor: [String],
    lineObj: {
      type: Object,
      default: () => ({}),
    },
    receiveItemDetail: {
      type: Boolean,
      default: false,
    },
    isByPartNumber: {
      type: Boolean,
      default: true,
    },
    PriceLabel: {
      type: String,
      default: 'Cust. Target Price',
    },
    BuyPriceLabel: {
      type: String,
      default: 'Target Buy Price',
    },
    ShowBuyPrice: {
      type: Boolean,
      default: true,
    },
    CompanyPNLabel: {
      type: String,
      default: 'Customer PN'
    },
    offerPrice: {
      type: Number,
      default: 0
    },
    showMOQ: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      part: {},
      line: {},
      header: {},
      requirementLine: {},
      reqFields: REQUIREMENT_FIELDS,
      invFields: INVENTORY_FIELDS,
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
      },
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      testings: [
        { name: 'Yes', value: true },
        { name: 'No', value: false },
      ],
      selectedPart: {},
      chosenPartNumber: null,
      leadFreeValues: LEAD_FREE_VALUES,
      partNumberSelected: false,
      havePart: false,
      isLoadingPart: false,
    }
  },
  computed: {
    ...mapState('requirementAdd', [
      'requirementLines',
    ]),
    ...mapGetters('requirementAdd', [
      'currentRequirementLine',
      'currentPart',
      'partNumbers',
    ]),
    ...mapGetters('lookup', [
      'manufacturers',
      'currencies',
      'conditions',
      'packaging',
      'classes',
      'categories',
      'countryCodes',
      'shipViaList',
    ]),
    ...mapGetters('quoteDetails', ['quoteById']),
    // ...mapState('address', [
    //   ,
    // ]),
    convertedPrice() {
      //The converted price is the unit price based on the entered price times the exchange rate
      let qty = this.line[this.reqFields.QUANTITY] || 0;
      let price = this.line[this.reqFields.PRICE] || 0;
      let exchangeRate = this.header[this.reqFields.EXCHANGE_RATE] || 1;

      return price * exchangeRate;
    },
    partId() {
      return this.part ? this.part.id : 0;
    }
  },
  methods: {
    ...mapActions('requirementAdd', [
      'getRequirementLines',
      'getShipViaList',
      'getPartNumbers',
      'getPartById',
    ]),
    async getList(partNumber) {
      await this.getPartNumbers(partNumber);

      return this.partNumbers;
    },
    async onSuggestSelect(suggestion) {
      console.log('Part Number Selected');
      this.selectedPart = {
        ...suggestion,
        partComments: suggestion.comments,
        comments: null
      };
      console.log('Selected Part Number: ' + this.selectedPart);
      this.partNumberSelected = true;

      await this.getPartById(suggestion.id);
      this.$emit('onSuggestSelect', suggestion);
    },
    async onSuggestChange() {
      this.isLoadingPart = true;
      this.$v.chosenPartNumber.$touch();
      if (this.selectedPart.partNumber && this.chosenPartNumber !== this.selectedPart.partNumber) {
        this.part = { id: 0 };
      }
    },
    async onPartNumberBlur() {
      if(this.chosenPartNumber) {
        if (this.partNumbers.length > 0) {
          const findIndex = this.partNumbers.findIndex(x => this.chosenPartNumber.toLowerCase() == x.partNumber.toLowerCase());

          if (findIndex > -1) {
            //this.onSuggestSelect(this.partNumbers[findIndex]);
          } else {
            this.partNotFoundConfirmation();
          }
        } else {
          this.partNotFoundConfirmation();
        }
      }
    },
    async partNotFoundConfirmation() {
      const deleteConfirmed = await this.openConfirmBox({
          message: `${this.chosenPartNumber} is not in the database. Press Continue to add the item.`,
          okTitle: 'Continue',
        });
        if (deleteConfirmed) {
          this.part = {
            id: 0,
            partNumber: this.chosenPartNumber
          };
          this.$bvModal.show('part-maintenance-model');
        }
    },

    onRequestDone() {
      this.isLoadingPart = false;
    },
    onValueChangePart({ name, value }) {
      this.part = {
        ...this.part,
        [name]: value,
      };
    },
    onValueChangeLine({ name, value }) {
      this.line = {
        ...this.line,
        [name]: value,
      };
    },
    onValueChangeHeader({ name, value }) {
      this.header = {
        ...this.header,
        [name]: value,
      }
    },
    async onPartBlur(){
      if(this.chosenPartNumber && !this.part.id) {

      }
      // $v.chosenPartNumber.$touch();
    },
    async onPartModelClose() {
      this.$bvModal.hide('part-maintenance-model');
    },
    async onPartCreated(e) {
      console.log('onPartCreated: ' + e);

      this.$bvModal.hide('part-maintenance-model');
      this.part = {
        ...e,
        partComments: e.comments,
        cost: e.cost || 0
      };
      this.chosenPartNumber = e.partNumber;
      //await this.getPartById(e.id);
      this.partNumberSelected = true;
      this.line[this.reqFields.PART_ID] = this.part.id;
    },
    async onPartUpdated(e) {
      console.log('onPartUpdated: ' + e);

      this.$bvModal.hide('part-maintenance-model');
      this.part = {
        ...e,
        partComments: e.comments,
        cost: e.cost || 0
      };
      this.chosenPartNumber = e.partNumber;
      //await this.getPartById(e.id);
      this.partNumberSelected = true;
      this.line[this.reqFields.PART_ID] = this.part.id;
    },
    setObjectsExistingLine() {
      console.log('Called Existing Obj', this.lineObj)
      if(this.addSources) {
        this.requirementLine = {
          ...this.lineObj,
          ...this.currentPart,
          [this.reqFields.PART_COMMENTS]: this.requirementLine[this.reqFields.COMMENTS],
        };

        this.requirementLine[this.reqFields.COMMENTS] = '';
        // this.requirementLine[this.reqFields.QUANTITY] = 0;
        // this.requirementLine[this.reqFields.PRICE] = 0;

        if(this.pageName === 'quotes') {
          const quote = this.quoteById(this.$route.params.id);

          this.requirementLine[this.reqFields.EXCHANGE_RATE] = quote[this.reqFields.EXCHANGE_RATE];
          this.requirementLine[this.reqFields.CURRENCY_TYPE_ID] = quote.currencyId;
        }
      } else {
        if(Object.keys(this.lineObj).length > 0) { //If line object prop used
          this.requirementLine = { ...this.lineObj };
        } else if(Object.keys(this.selectedPart).length === 0) {
          this.requirementLine = this.currentRequirementLine(this.crfqLineId);
        } else {
          this.requirementLine = this.selectedPart;
        }
      }
      console.log(this.requirementLine, 'REquirement Lien', Object.keys(this.selectedPart).length === 0)
      this.chosenPartNumber = this.requirementLine.partNumber;

      this.part = {
        id: Object.keys(this.selectedPart).length === 0 ? this.requirementLine[this.reqFields.PART_ID] : this.requirementLine[this.reqFields.ID],
        partNumber: this.requirementLine[this.reqFields.PART_NUMBER],
        manufacturerId: this.requirementLine[this.reqFields.MANUFACTURER_ID],
        inventoryClassId: this.requirementLine[this.reqFields.CLASS_ID] || this.requirementLine.inventoryClassId,
        inventoryCategoryId: this.requirementLine[this.reqFields.CATEGORY_ID] || this.requirementLine.inventoryCategoryId,
        packageId: this.requirementLine[this.reqFields.PACKAGE_ID],
        tempRating: this.requirementLine[this.reqFields.TEMP_RATING],
        leadFree: this.requirementLine[this.reqFields.LEAD_FREE],
        partComments: this.requirementLine[this.reqFields.PART_COMMENTS],
        nsnNumber: this.requirementLine[this.reqFields.NSN_NUMBER],
        harmonizedCode: this.requirementLine[this.reqFields.HARMONIZED_CODE],
        altNumber: this.requirementLine[this.reqFields.ALT_NUMBER],
        description: this.requirementLine[this.reqFields.DESCRIPTION],
        scheduleB: this.requirementLine[this.reqFields.SCHEDULE_B],
        eccn: this.requirementLine[this.reqFields.ECCN],
        piecePerPkg: this.requirementLine[this.reqFields.PIECE_PER_PKG],
        moq: this.requirementLine[this.reqFields.MOQ],
        active: true,
      };

      this.line = {
        ...this.line,
        id: Object.keys(this.selectedPart).length === 0 ? this.requirementLine[this.reqFields.ID] : 0,
        requirementId: this.requirementLine[this.reqFields.REQUIREMENT_ID],
        partId: Object.keys(this.selectedPart).length === 0 ? this.requirementLine[this.reqFields.PART_ID] : this.requirementLine[this.reqFields.ID],
        conditionId: this.requirementLine[this.reqFields.CONDITION_ID],
        quantity: this.requirementLine[this.reqFields.QUANTITY],
        customerPN: this.requirementLine[this.reqFields.CUSTOMER_PN],
        dateCode: this.requirementLine[this.reqFields.DATE_CODE],
        lotCode: this.requirementLine[this.reqFields.LOT_CODE],
        revision: this.requirementLine[this.reqFields.REVISION],
        price: (this.offerPrice > 0) ? this.offerPrice : this.requirementLine[this.reqFields.PRICE],
        convertedPrice: this.convertedPrice,
        buyPrice: this.requirementLine[this.reqFields.BUY_PRICE],
        vendorNote: this.requirementLine[this.reqFields.VENDOR_NOTE],
        comments: this.requirementLine[this.reqFields.COMMENTS],
        needByDate: (this.requirementLine[this.reqFields.NEED_BY_DATE]) ? moment(this.requirementLine[this.reqFields.NEED_BY_DATE]).format(DATE_FORMAT) : null,
        testingRequested: this.requirementLine[this.reqFields.TESTING_REQUESTED],
        shippingMethodId: this.requirementLine[this.reqFields.SHIPPING_METHOD_ID],
        active: true,
        statusId: this.requirementLine.statusId || this.line.statusId,
        countryOfOriginId: this.requirementLine.countryOfOriginId,
        purchaseOrderId: this.requirementLine.purchaseOrderId,
        purchaseOrderLineId: this.requirementLine.id,
        salesOrderLineId: this.requirementLine.salesOrderLineId,
      };

      this.header = {
        currencyTypeId: this.requirementLine[this.reqFields.CURRENCY_TYPE_ID] || 1,
        exchangeRate: this.requirementLine[this.reqFields.EXCHANGE_RATE] || 1,
        active: true,
      };
    },
    clearForm() {
      this.part = {};
      this.line = {};
      this.header = {
        exchangeRate: 1,
        currencyTypeId: 1,
        active: true,
      };
      this.chosenPartNumber = '';
      this.selectedPart = {};
      this.partNumberSelected = false;
    },
    getFormValidation() {
      this.$v.$touch();
      this.$emit('form-validation', this.$v.$invalid);
    }
  },
  watch: {
    part: {
      handler() {
        this.$emit('partChange', this.part);
      },
      deep: true,
    },
    line: {
      handler() {
        this.$emit('lineChange', this.line);
      },
      deep: true,
    },
    header: {
      handler() {
        this.$emit('headerChange', this.header);
      },
      deep: true,
    },
    chosenPartNumber() {
      if (this.part) {
        this.part.partNumber = this.chosenPartNumber;
      }
    },
    currentPart() {
      this.setObjectsExistingLine();
    },
    requirementLines() {
      this.setObjectsExistingLine();
    },
    lineObj() {
      console.log('calling lineObj watcher');

      this.setObjectsExistingLine();
    },
    convertedPrice() {
      this.line.convertedPrice = this.convertedPrice;
    },
  },
  async created() {
    if(this.addSources || Object.keys(this.lineObj).length > 0) {
      this.partNumberSelected = true;
    }

    if(Object.keys(this.lineObj).length > 0) { //If line object prop used
      //this.requirementLine = { ...this.lineObj };
      console.log(this.lineObj, 'Line Obj value')
      await this.setObjectsExistingLine();
    } else if(this.requirementId && !this.crfqLineId) { //If already added requirement, but no line
      this.line = {
        id: 0,
        requirementId: this.requirementId,
        statusId: 133,
        active: true,
      };

      this.part = {
        id: 0,
        partNumber: '',
        active: true,
      };

      this.header = {
        exchangeRate: 1,
        currencyTypeId: 1,
        active: true,
      };
    } else if(this.requirementId && this.crfqLineId) { //If already addded requirement line, so edit
      //If hasn't received Vuex data yet TODO: figure out how to prevent need for duplicated AJAX call
      if(!this.requirementLines) await this.getRequirementLines(this.requirementId);

      await this.setObjectsExistingLine();
    } else {
      this.line = {
        id: 0,
        requirementId: 0,
        statusId: 133,
        partId: 0,
        active: true,
      };

      this.part = {
        id: 0,
        partNumber: '',
        active: true,
      };

      this.header = {
        exchangeRate: 1,
        currencyTypeId: 1,
        active: true,
      };
    }

    if (this.$route.query.partId) {
      await this.getPartById(this.$route.query.partId);
    }
  },
  validations: {
    chosenPartNumber: { required },
    line: {
      [REQUIREMENT_FIELDS.QUANTITY]: { required },
      [REQUIREMENT_FIELDS.PRICE]: { required },
    },
  },
}
</script>

<style lang="scss">
.part-lookup {
  &--plus {
    font-size: 10px;
  }
}

#part-maintenance-model .modal-dialog {
  max-width: 1550px !important;
}
</style>
